import React from 'react'

import { ReactComponent as Loader } from "./barchartloader.svg";

export const LoaderImage : React.FC = () => {
  return (
    <Loader />
  )
}
